import { h } from "preact";
import { combinePromises } from "@jaybeeuu/utilities";
export const withPromise = ({ Pending, Failed, Content, }) => {
    const FetchCompleteComponent = (ownProps) => {
        const promise = combinePromises(ownProps);
        switch (promise.status) {
            case "pending":
                return h(Pending, null);
            case "complete": {
                // @ts-expect-error Maybe promises is a compound type using the keys on ContentProps, TypeScript is unhappy because it thinks that ContentProps could be a class, but.... it can't it will always be a map.
                return h(Content, { ...promise.value });
            }
            case "failed":
                return h(Failed, { error: promise.error });
        }
    };
    FetchCompleteComponent.displayName = `WithPromise(${Content.displayName ?? Content.name})`;
    return FetchCompleteComponent;
};
//# sourceMappingURL=with-promise.js.map